/* eslint-disable no-undef */
import styled from 'styled-components';
import DoubleArrowRight from '../../assets/images/double-arrow-right-icon.svg';

const DoubleArrowRightIcon = styled.span`
  background: url(\"${DoubleArrowRight}\") no-repeat center center;
  background-size: 23px 21px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  height: 50px;
  width: 50px;
`;

export default DoubleArrowRightIcon;
